import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import INTERNAL_LINKS from "../../enum/InternalLinks";

const PrivateRoute = ({
  ...props
}) => {
  const redirect = INTERNAL_LINKS.LOGIN;
  const [user] = useState({});
  const [isAuthenticated] = useState(window.localStorage.access_token !== undefined);

  return isAuthenticated ? (
    <Route {...props } user={user} />
  ) : (
    <Redirect
      to={{
        pathname: redirect,
      }}
    />
  );
};

export default PrivateRoute;
